import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import PanelBarProps from './PanelBarProps'

import Animation from './Animation'
import Messages from './Messages'

export default {
    props: PanelBarProps,
    render (h) {
        return h('ul',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        Messages
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoPanelBar(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPanelBar()
        },
        _resolveChildren() {
            if(this.$options.propsData && !this.$options.propsData['dataSource'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-panelbar-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/KendoPanelBarMixin.js